import { MDBBtn, MDBDatatable, MDBIcon } from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import AddToUsers from "../../../views/popups/misc/AddToUsers";
import { useTranslation } from "react-i18next";
import AADialByNameAdd from "../../../views/popups/autoattendant/AADialByNameAdd";
import DeleteAADirectory from "../../../views/popups/autoattendant/DeleteAADirectory";
import PopupLoader from "../../../views/popups/PopupLoader";
import DailByDirectoriesSettings from "../../topviews/DailByDirectoriesSettings";
import AADialByNameEdit from "../aagroup/AADialByNameEdit";
import { useFormContext } from "react-hook-form";
import { customSearch } from "../../CustomSearchUtil/CustomSearch";

function LunaUsers({
  // register,
  // setValue,
  // watch,
  // errors,
  // setError,
  // clearErrors,
  users,
  setSuccessMessage,
  selectedItem,
  setSelectedItem,
}) {
  const [addUsers, setAddUsers] = useState(false);
  const addUserRef = useRef(null);
  const [groupUsers, setGroupUsers] = useState([]);
  const [updateUsers, setUpdateUsers] = useState([]);
  const [isAddedUsers, setIsAddedUsers] = useState(false);
  const [sourceUsers, setSourceUsers] = useState([]);
  const [directoryUserList, setdirectoryUserList] = useState([]);
  const [directorys, setdirectorys] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [primaryId, setprimaryId] = useState("");
  const [centredModal, setCentredModal] = useState(false);
  const toggleShow = () => setCentredModal(!centredModal);
  const [newDirectory, setnewDirectory] = useState({});
  const [isdeleteDir, setIsDeleteDir] = useState(false);
  const dtogglePopup = () => setIsDeleteDir(!isdeleteDir);
  const [directoryid, setDirectoryId] = useState(0);
  const [isDirectDeleted, setisDirectDeleted] = useState(false);
  const { t, i18n } = useTranslation();
  const [directoryInfo, setdirectoryInfo] = useState({});
  const [showEdit, setshowEdit] = useState(false);
  const toggleeditPopup = () => setshowEdit(!showEdit);
  const [isDirectoryEditedData, setisDirectoryEditedData] = useState({});
  const [includeList, setincludeList] = useState([]);
  const [excludeList, setexcludeList] = useState([]);
  const [existSelectedItem, setexistSelectedItem] = useState(null);
  const {
    setValue,
    watch,
    clearErrors,
    unregister,
    formState: { errors },
  } = useFormContext();

  const closeTogglePopup = () => {
    setAddUsers(!addUsers);
  };

  function handleClick() {
    addUserRef.current.click();
  }
  // alert("in users page :::::::");
  function handleMakePrimary(e, dirId) {
    // setprimaryId(dirId);
    setValue("user.val", dirId, { shouldDirty: true });
  }

  useEffect(() => {
    if (Array.isArray(users) && users.length > 0) {
      setincludeList(
        users
          .filter((item) => item.type === 0)
          .map((item) => ({ name: item.name, id: item.id }))
      );
      setexcludeList(
        users
          .filter((item) => item.type === 1)
          .map((item) => ({ name: item.name, id: item.id }))
      );
      if (
        watch("user.val") &&
        watch("user.val") !== "" &&
        watch("user.is_perm_enabled")
      ) {
        const userObj = users.find(
          (item) => parseInt(item.id) === parseInt(watch("user.val"))
        );
        if (userObj) {
          setSelectedItem({ name: userObj.name, id: userObj.id });
          setexistSelectedItem(watch("user.val"));
        }
      } else {
        setexistSelectedItem(null);
      }

      // setdirectoryUserList(users);
    } else {
      setdirectoryUserList([]); // Ensure it's always an array
    }
  }, [users]);

  useEffect(() => {
    if (newDirectory && Object.entries(newDirectory).length > 0) {
      const updatedDirectory = [...directoryUserList, newDirectory];
      setdirectoryUserList(updatedDirectory);
      setnewDirectory({});
    }
  }, [newDirectory]);

  useEffect(() => {
    if (isDirectDeleted && directoryid) {
      const updatedDirectory = directoryUserList.filter(
        (dir) => dir.id !== directoryid
      );
      setdirectoryUserList(updatedDirectory);
      setisDirectDeleted(false);
    }
  }, [isDirectDeleted]);

  useEffect(() => {
    if (
      isDirectoryEditedData &&
      Object.entries(isDirectoryEditedData).length > 0
    ) {
      const updatedDirectory = directoryUserList.map((dir) => {
        if (dir.id === isDirectoryEditedData.id) {
          return { ...dir, ...isDirectoryEditedData };
        }
        return dir;
      });
      setdirectoryUserList(updatedDirectory);
      setisDirectoryEditedData({});
    }
  }, [isDirectoryEditedData]);

  function handleRowClick(tdata) {
    setdirectoryInfo(tdata);
    toggleeditPopup();
  }
  const include = "Include List";
  const exclude = "Exclude List";

  const groupedData = {
    [include]: includeList,
    [exclude]: excludeList,
  };

  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState("");
  const [showOptions, setShowOptions] = useState(false);
  const dropdownRef = useRef(null);

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setShowOptions(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // const filteredGroups = Object.entries(groupedData)
  //   .map(([group, items]) => {
  //     const filteredItems = items.filter((item) =>
  //       item.name.toLowerCase().includes(search.toLowerCase())
  //     );
  //     return { group, items: filteredItems };
  //   })

  const filteredGroups = Object.entries(groupedData).map(([group, items]) => {
    const filteredItems = customSearch(items, search, ["name"]);
    return { group, items: filteredItems };
  })
    .filter((group) => group.items.length > 0);

  const handleSelectItem = (item) => {
    setSelectedItem(item);
    setShowOptions(false);
    setSearch("");
    clearErrors("user.is_perm_enabled");
    // Update form value with the selected item's ID
    setValue("user.val", item.id, { shouldDirty: true });
  };

  return (
    <>
      <div className="section-content">
        <div
          className="d-flex align-items-center justify-content-between mb-3"
          style={{ paddingRight: "20px" }}
        >
          <div className="general-settings m-0">Users</div>
          <div className="phoneselect">
            <label className="switch">
              <input
                className="form-control"
                type="checkbox"
                name="DefualtLocation"
                checked={watch("user.is_perm_enabled")}
                onChange={(e) => {
                  clearErrors(`user.is_perm_enabled`);
                  setValue(`user.is_perm_enabled`, e.target.checked, {
                    shouldDirty: true,
                  });
                  if (!selectedItem && e.target.checked) {
                    const userObj =
                      users.find((item) => item.flag === 1) ??
                      users.find((item) => item.defaultval === 1);
                    setSelectedItem({ name: userObj.name, id: userObj.id });
                    setValue("user.val", userObj.id, { shouldDirty: true });
                  } else if (!existSelectedItem) {
                    setSelectedItem(null);
                    unregister("user.val");
                  }
                }}
              />
              <span className="slider round"></span>
            </label>
            {errors?.user?.is_perm_enabled && (
              <p className="text-danger">
                {errors?.user?.is_perm_enabled?.message}
              </p>
            )}
          </div>
        </div>
        {watch("user.is_perm_enabled") && (
          <div className="add-numbermain ">
            <div class="tel-numbers w-60">
              Directory List
              <br />
              <span class="phrecording text-secondaryd-inline-block">
                By default, all users are included. You can select an exclude
                list to remove specific users from the default list, or select
                an include list to limit access to only the users in that list.
              </span>
            </div>
            <div className="w-30">
              <div className="select-wrapper-custom w-100" ref={dropdownRef}>
                <div
                  className="form-select"
                  onClick={() => setShowOptions(!showOptions)}
                >
                  {selectedItem ? selectedItem.name : "Select a directory"}
                </div>
                {showOptions && (
                  <div className="Luna-dropdown">
                    <input
                      type="text"
                      autoFocus
                      className="search-input"
                      placeholder="Search..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <div className="options">
                      {filteredGroups.map(({ group, items }) => (
                        <div key={group}>
                          <div className="option-group">{group}</div>
                          {/* {items.map((item) => (
                        <div
                          key={item.id}
                          value={item.name}
                          className="option-item"
                          onClick={() => {
                            setSelected(item);
                            setShowOptions(false);
                            setSearch("");
                          }}
                        >
                          {item}
                        </div>
                      ))} */}
                          <div className="option-items">
                            {items.map((item) => (
                              <div
                                key={item.id}
                                className={`option-item ${
                                  selectedItem?.id === item.id ? "selected" : ""
                                }`}
                                onClick={() => handleSelectItem(item)}
                              >
                                {item.name}
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                      {filteredGroups.length === 0 && (
                        <div className="no-results">No results found</div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {centredModal && (
        <PopupLoaderNew
          size="md"
          className="modal-md"
          title={t("addDirectoryList")}
          content={
            <AADialByNameAdd
              onClose={toggleShow}
              ref={addUserRef}
              setIsloading={setisLoading}
              lunaUser={true}
              setSuccessMessage={setSuccessMessage}
              setnewDirectory={setnewDirectory}
            />
          }
          onShow={setCentredModal}
          onClose={toggleShow}
          onSave={handleClick}
          isloading={isLoading}
          flag={1}
        />
      )}

      {isdeleteDir && (
        <PopupLoaderNew
          title={"Remove Directory"}
          content={
            <DeleteAADirectory
              directoryid={directoryid}
              // groupcode={props.aagcode}
              onClose={dtogglePopup}
              setSuccessMessage={setSuccessMessage}
              ref={addUserRef}
              setIsloading={setisLoading}
              lunaUser={true}
              setisDirectDeleted={setisDirectDeleted}
            />
          }
          onShow={setIsDeleteDir}
          onClose={dtogglePopup}
          onSave={handleClick}
          isloading={isLoading}
          flag={4}
        />
      )}

      {showEdit && (
        <PopupLoader
          size="xl"
          title={"Edit Directory"}
          content={
            <AADialByNameEdit
              popupAA={true}
              onClose={toggleeditPopup}
              setSuccessMessage={setSuccessMessage}
              directoryInfo={directoryInfo}
              lunaUser={true}
              setisDirectoryEditedData={setisDirectoryEditedData}
            />
          }
          onShow={setshowEdit}
          onClose={toggleeditPopup}
        />
      )}
    </>
  );
}

export default React.memo(LunaUsers);
